/* eslint-disable jsx-a11y/anchor-is-valid */

import { Component } from "react";
import axios from "axios";

import FormatUtils from "../../utils/formatUtils";
import { BACKEND_CONFIG } from "../../config/consts";
import { creatBlobFromBase64 } from "../../utils/utils";

class DocumentBody extends Component {
  constructor(props) {
    super(props);

    this.getDocument = this.getDocument.bind(this);
  }

  getClientIdFromUri() {
    let path;

    if (window.location.href[window.location.href.length] === "/")
      path = window.location.href
        .substr(0, window.location.href.length - 1)
        .split("/");
    else {
      //get rid of query params
      path = window.location.href.split("?")[0];
      path = path.split("/");
    }

    return path[path.length - 1];
  }

  getDocument() {
    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}documents/${this.getClientIdFromUri()}/files/${
          this.props.data.Data["Id"]
        }/content`
      )
      .then(({ data }) => {
        const blob = creatBlobFromBase64(data.Content, data.ContentType);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, data.FileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          if (data.ContentType === "application/pdf") {
            window.open(url);
          } else {
            const a = window.document.createElement("a");
            window.document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = data.FileName;
            a.click();
            setTimeout(() => {
              window.document.body.removeChild(a);
            }, 0);
          }
        }
      });
  }

  render() {
    return (
      <div>
        <div className={"communications-title"}>
          <span>{this.props.data.Title}</span>
          <a
            rel="noopener noreferrer"
            target="_blank"
            className={"view-button float-right"}
            onClick={this.getDocument}
          >
            View
          </a>
        </div>
        <div className={"clear communications-desc"}>
          <span>{this.props.data.Data.Description}</span>
        </div>
        <div className={"communications-data"}>
          <div className="data-line">
            <span className={"key-data"}>Date Created:</span>
            <span className="value-data float-right">
              {FormatUtils.formatDate(this.props.data.Date)}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default DocumentBody;
